// Spec 2026-02-XX rev22 (Point Q) + rev24 (Point S) — dérivation d'un
// nom court ≤ 20 caractères depuis un nom complet.
//
// Utilisé côté frontend pour :
//  • Prérenser le champ "Nom court" dans le dialog Type (create).
//  • Bouton "↺ Regénérer auto" dans la table admin Types (rev24).
//
// Miroir exact de l'algorithme backend `_derive_short_name` — voir
// backend/routes/document_type_routes.py. Toute modif ici DOIT être
// répercutée là-bas (et vice-versa) sinon les valeurs prévisualisées
// divergent des valeurs finalement persistées par le serveur.
export const SHORT_NAME_MAX = 20;

export function deriveShortName(name) {
  const n = (name || "").trim().replace(/\s+/g, " ");
  if (!n) return "";
  if (n.length <= SHORT_NAME_MAX) return n;
  const words = n.split(" ");
  const acc = [];
  let total = 0;
  for (const w of words) {
    const add = (acc.length ? 1 : 0) + w.length;
    if (total + add > SHORT_NAME_MAX) break;
    acc.push(w);
    total += add;
  }
  const wordsOnly = acc.length ? acc.join(" ").replace(/\s+$/, "") : "";
  // rev26 (2026-02-XX) — pas d'ellipsis dans le short_name. Un short_name
  // est un nom court propre, pas une chaîne visiblement tronquée.
  if (wordsOnly.length < 10) {
    return n.slice(0, SHORT_NAME_MAX).replace(/\s+$/, "");
  }
  return wordsOnly;
}
